//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import shopStockInBuyOrderManager from "@/Manager/04.Sms/ShopStockInBuyOrderManager";
export default {
  props: ["controlItem"],
  components: {},
  data() {
    return {
      sms: "",
      err: "",
      show: true,
      count: "",
      phoneRegex: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
    };
  },
  methods: {
    async getCodes() {
      if (!this.phoneRegex.test(this.controlItem.ControlValue))
        return this.$msg.alert("请输入正确的手机号码");
      if (this.isVcodeSend) return;

      if (
        this.controlItem.ControlUrl.SendCodeUrl == "" ||
        this.controlItem.ControlUrl.SendCodeUrl == null
      ) {
        this.$msg.alert("找不到相关的Url");
        return;
      }

      var url = this.controlItem.ControlUrl.SendCodeUrl;
      sessionStorage.setItem("Url", url);

      this.$msg.showLoading();
      var opneId = this.controlItem.OpenId;

      var tplPostData = this.$parent.getSubmitData();
      tplPostData["Mobile"] = this.controlItem.ControlValue;
      tplPostData["OpenId"] = opneId;

      shopStockInBuyOrderManager.SendIphoneCode(tplPostData).then(result => {
        this.$msg.hideLoading();
        if (result.state == 1) {
          this.$msg.succ();
          this.timers();
          return;
        }
        console.log(result);
        this.$msg.alert(result.msg);
      });
    },
    // 倒计时
    timers() {
      const TIME_COUNT = 120;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    ChangeSmsCode() {
      console.log(this.sms, "0---==-ookk0p-[0p");
      sessionStorage.setItem("smsCheckCode", this.sms);
    }
  },
  created() {
    console.log(this.sms, "0---==-ookk0p-[0p");
    sessionStorage.setItem("smsCheckCode", "0");
  },

  mounted() {}
};
